import {User as FirebaseUser} from 'firebase/auth';
import {User} from './User.ts';

export type PendingOnboardingUser = {
    kind: 'pending_onboarding';
    firebaseUser: FirebaseUser;
};

export type AuthState = User | PendingOnboardingUser | null;

export function isPendingOnboardingUser(state: AuthState): state is PendingOnboardingUser {
    return state !== null && typeof state === 'object' && 'kind' in state && state.kind === 'pending_onboarding';
}

export function isAuthenticatedUser(state: AuthState): state is User {
    return state !== null && !isPendingOnboardingUser(state);
}
